module.exports = __webpack_public_path__ + "img/footer_icon_youtube.02b00372.svg";